export default __webpack_public_path__ + "static/media/Tro.8180b5f4.png";